import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import INftSoccerGames from '../Card/INftSoccerGamesCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function NftSoccerGamesDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<INftSoccerGames | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)
  const tokenName = detailTokenItem ? detailTokenItem.name : collection.name
  const tokenImage = detailTokenItem ? detailTokenItem.image : ''
  const extarnalUrl = detailTokenItem ? detailTokenItem.external_url : ''
  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTDescription() {
    return (
      <div>
        <p>
          NFT Soccer Games is a digital soccer game based on Avalanche Contract Chain where you can own your unique
          ERC-721 tokens and enjoy an enthusiastic soccer experience. NFT generation and the main platform token
          generation will be placed on layer 1 and game dynamics will be built on layer 2.
        </p>
      </div>
    )
  }

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem) {
      result = [
        ...detailTokenItem.attributes.map(item => ({
          key: item.trait_type,
          value: item.value,
          isUrl: false,
          show: true
        })),
        {
          key: 'Star',
          value: detailTokenItem.star.toString(),
          isUrl: false,
          show: true
        },
        {
          key: 'Dna',
          value: detailTokenItem.dna,
          isUrl: false,
          show: true
        }
      ]
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      tokenItemName={tokenName}
      properites={getNFTProperties()}
      description={getNFTDescription()}
      externalUrl={extarnalUrl}
    >
      {detailTokenItem ? <img src={tokenImage} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
